// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveEnum } from '@/constants/case-insensitive-enum';

// Mirrors `enums.ChargeMode` on the BE. PENDING plans are
// dateless / awaiting activation; CONFIRMED plans have an activation
// anchor and concrete charge dates.
export const chargeModeSchema = caseInsensitiveEnum(['CONFIRMED', 'PENDING']);
